var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 1.25C4.3116 1.25 3.25179 1.68899 2.47039 2.47039C1.68899 3.25179 1.25 4.3116 1.25 5.41667C1.25 6.52174 1.68899 7.58154 2.47039 8.36294C3.25179 9.14435 4.3116 9.58333 5.41667 9.58333C6.52174 9.58333 7.58154 9.14435 8.36294 8.36294C9.14435 7.58154 9.58333 6.52174 9.58333 5.41667C9.58333 4.3116 9.14435 3.25179 8.36294 2.47039C7.58154 1.68899 6.52174 1.25 5.41667 1.25ZM0 5.41667C0 3.98008 0.570683 2.60233 1.5865 1.5865C2.60233 0.570683 3.98008 0 5.41667 0C6.85326 0 8.23101 0.570683 9.24683 1.5865C10.2627 2.60233 10.8333 3.98008 10.8333 5.41667C10.8333 6.85326 10.2627 8.23101 9.24683 9.24683C8.23101 10.2627 6.85326 10.8333 5.41667 10.8333C3.98008 10.8333 2.60233 10.2627 1.5865 9.24683C0.570683 8.23101 0 6.85326 0 5.41667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72502 8.72502C8.84221 8.60798 9.00106 8.54224 9.16669 8.54224C9.33231 8.54224 9.49116 8.60798 9.60835 8.72502L12.9417 12.0584C13.0031 12.1156 13.0523 12.1846 13.0865 12.2612C13.1207 12.3379 13.139 12.4207 13.1405 12.5046C13.142 12.5885 13.1266 12.6719 13.0951 12.7497C13.0637 12.8275 13.0169 12.8982 12.9576 12.9576C12.8982 13.0169 12.8275 13.0637 12.7497 13.0951C12.6719 13.1266 12.5885 13.142 12.5046 13.1405C12.4207 13.139 12.3379 13.1207 12.2612 13.0865C12.1846 13.0523 12.1156 13.0031 12.0584 12.9417L8.72502 9.60835C8.60798 9.49116 8.54224 9.33231 8.54224 9.16669C8.54224 9.00106 8.60798 8.84221 8.72502 8.72502Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.bc8a2d5e0010173fe3f60a5692bbda53.svg";
export { ForwardRef as ReactComponent };